<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { langUrl, closePopup } from '@/helpers'
import { useLangStore } from '@/stores/app/lang'
import { useMenuStore } from '@/stores/gallery/menu'

const menuStore = useMenuStore()

// State -----------------------------------------
const { lang } = storeToRefs(useLangStore())

// Getters ---------------------------------------
const placeMenus = computed(() => menuStore.placeMenus)
const categoryMenus = computed(() => {
  return menuStore.categoryMenus
})

// Methods ---------------------------------------
function imgMenuPlace(menu) {
  const status = menu.enable ? (menu.actived ? 'a' : 'b') : 'b'
  return langUrl(`/images/gallery/menu/th/menu-p${menu.id}-${status}.png`)
}

function imgMenuCategory(menu) {
  const status = menu.enable ? (menu.actived ? 'c' : 'a') : 'b'
  return langUrl(`/images/gallery/menu/th/menu-c${menu.id}-${status}.${menu.actived ? 'gif' : 'png'}`)
}

// Events ----------------------------------------
function onClickMenuPlace(menu) {
  if (menu.enable && menu.id !== menuStore.place) {
    closePopup()
    menuStore.changeMenuPlace(menu.id)
  }
}

function onClickMenuCategory(menu) {
  if (menu.enable && menu.id !== menuStore.category) {
    closePopup()
    menuStore.changeMenuCategory(menu.id)
  }
}

// menuStore.$subscribe((mutation, state) => {
//   console.debug('%c[GalleryMenu] $subscribe ->', style.debug, { ...state })
// })

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <transition name="fade-lang">
    <div class="gallery-menu" :key="lang" :lang="lang">
      <div class="menu-wrapper">
        <!------------------------------------->
        <transition-group name="fade-place">
          <img
            v-for="menu in placeMenus"
            class="menu"
            :key="imgMenuPlace(menu)"
            :src="imgMenuPlace(menu)"
            :lang="lang"
            :place="menu.id"
            :enable="menu.enable"
            @click="onClickMenuPlace(menu)"
          />
        </transition-group>
        <!------------------------------------->
        <transition-group name="fade-category">
          <img
            v-for="menu in categoryMenus"
            class="menu"
            :key="imgMenuCategory(menu)"
            :src="imgMenuCategory(menu)"
            :lang="lang"
            :category="menu.id"
            :enable="menu.enable"
            @click="onClickMenuCategory(menu)"
          />
        </transition-group>
        <!------------------------------------->
      </div>
    </div>
  </transition>
</template>

<style scoped>
/* ------------------------ */
.fade-place-enter-active,
.fade-place-leave-active {
  transition: opacity 0.5s ease;
}
.fade-place-enter-from,
.fade-place-leave-to {
  opacity: 0;
}

/* ------------------------ */
.fade-category-enter-active,
.fade-category-leave-active {
  transition: opacity 0.3s ease;
}
.fade-category-enter-from,
.fade-category-leave-to {
  opacity: 0;
}

/* ------------------------ */
.gallery-menu {
  position: absolute;
  top: 1px;
  width: var(--app-width);
  height: 59px;
  z-index: var(--layer-2);
}

.menu {
  position: absolute;
  top: 0;
}

.menu[enable='true'] {
  cursor: pointer;
  /* opacity: .5; */
}

/* ------------------------ */
.menu[place='1'] {
  left: 55px;
}

.menu[place='2'] {
  left: 221px;
}

.menu[lang='en'][place='1'] {
  left: 0;
}

.menu[lang='en'][place='2'] {
  left: 131px;
}

/* ------------------------ */
.menu[category='1'] {
  left: 332px;
}

.menu[category='2'] {
  left: 457px;
}

.menu[category='3'] {
  left: 652px;
}

.menu[category='4'] {
  left: 793px;
}

.menu[category='5'] {
  left: 910px;
}

.menu[lang='en'][category='1'] {
  left: 274px;
}

.menu[lang='en'][category='2'] {
  left: 399px;
}

.menu[lang='en'][category='3'] {
  left: 574px;
}

.menu[lang='en'][category='4'] {
  left: 782px;
}

.menu[lang='en'][category='5'] {
  left: 905px;
}
/* ------------------------ */
</style>
